<app-wizard-bar-nav></app-wizard-bar-nav>
<div class="step-container">
  <div>
    <h2 *ngIf="renewalsCustomerDetailsData.originalQuoteRequestId">
      Renewing Quote {{ renewalsCustomerDetailsData.originalQuoteRequestId }}
    </h2>
    <h3>Customer Details | <em heading-info [quoteInfo]="renewalsCustomerDetailsData.quoteRequestState"></em></h3>

    <h3 *ngIf="renewalsCustomerDetailsData.isQuickSubmission">Hello, Quick Submit!</h3>

    <form [formGroup]="frmCompanyDetails">
      <h4 *ngIf="!renewalsCustomerDetailsData.userIdentity?.isBroker">Quote on Behalf of a Brokerage</h4>
      <section *ngIf="!renewalsCustomerDetailsData.userIdentity?.isBroker" class="field-group">
        <div class="field-holder w2">
          <mat-form-field appearance="standard">
            <mat-label>Brokerage</mat-label>
            <input matInput type="text" formControlName="brokerage" (change)="brokerageChange($event.target.value)" />
            <mat-error *ngIf="showBrokerageMaxLengthError"> Maximum length is 255 characters </mat-error>
          </mat-form-field>
        </div>

        <div class="field-holder w2">
          <mat-form-field appearance="standard">
            <mat-label>Broker</mat-label>
            <input matInput type="text" formControlName="broker" disabled />
            <mat-error *ngIf="showBrokerMaxLengthError"> Maximum length is 255 characters </mat-error>
          </mat-form-field>
        </div>
      </section>

      <app-customer-details
        formControlName="customerDetails"
        [customerDetails]="renewalsCustomerDetailsData.companyDetails"
        [showValidation]="renewalsCustomerDetailsData.showValidation"
        [dunsLookupEnabled]="renewalsCustomerDetailsData.dunsEnabled"
        (propagateAddressFound)="storeUtilityInformation($event)"
      ></app-customer-details>

      <div *ngIf="!(isSupplierManagerManualEntry() | async)">
        <h4>Letter of Authority <em id="optional">(Optional)</em></h4>
        <section class="loaUpload">
          <span *ngIf="frmCompanyDetails.disabled && renewalsCustomerDetailsData.files?.length === 0">No LOA provided</span>
          <app-upload
            [waitForConfirmationFunc]="resolveWaitForUploadConfirmation"
            (after-closed)="onCompleteUpload($event)"
            [document-type]="'LoaDocument'"
            [upload-description]="'Drag and drop your LOA here'"
            [disabled]="frmCompanyDetails.disabled"
          ></app-upload>

          <ul class="file-list">
            <li *ngFor="let file of renewalsCustomerDetailsData.files">
              <div class="delete-file">
                <a class="download-link" appDownloadLink [file]="file">{{ file.fileName }}</a>
                <app-delete-file
                  [file]="file"
                  [quoteRequestId]="renewalsCustomerDetailsData.quoteRequestId"
                  (after-delete)="onDeleteUpload($event)"
                  [disabled]="frmCompanyDetails.disabled"
                  [changeInvalidatesQuoteRequest]="this.isQuoteRequestInvalidated()"
                >
                </app-delete-file>
              </div>
            </li>
          </ul>
        </section>
      </div>

      <h4>Supply Details</h4>

      <div class="field-holder w2" style="margin-bottom: 10px">
        <mat-radio-group
          aria-label="Select an option"
          name="commodityType"
          formControlName="commodityType"
          (change)="this.commodityChanged($event)"
        >
          <mat-radio-button
            value="Electricity"
            style="margin-right: 10px"
            [disabled]="!renewalsCustomerDetailsData.isElectricEnabled"
            [checked]="renewalsCustomerDetailsData.isElectricChecked"
          >
            <img [src]="'/assets/icons/icon-electricity.svg'" style="height: 20px; padding-top: 5px; padding-right: 10px" />Electricity
          </mat-radio-button>

          <mat-radio-button
            value="Gas"
            [disabled]="!renewalsCustomerDetailsData.isGasEnabled"
            [checked]="renewalsCustomerDetailsData.isGasChecked"
          >
            <img [src]="'/assets/icons/icon-gas.svg'" style="height: 20px; padding-top: 5px; padding-right: 10px" />Gas
          </mat-radio-button>
        </mat-radio-group>
      </div>

      <app-utility-details-presentation
        formControlName="utilityDetails"
        quoteRequestType="Custom"
        [iso]="renewalsCustomerDetailsData.iso"
        [zones]="renewalsCustomerDetailsData.zones"
        [showValidation]="renewalsCustomerDetailsData.showValidation"
        [weatherZones]="renewalsCustomerDetailsData.weatherZones"
        (utilitySelected)="utilitySelected($event)"
        (utilityUomSelected)="utilityUomSelected($event)"
        [showControls]="{
          loadingUtilities: renewalsCustomerDetailsData.loadingUtilities,
          emitEventOnValueChange: renewalsCustomerDetailsData.emitEventOnValueChange
        }"
      >
      </app-utility-details-presentation>

      <h4>Contract Details</h4>
      <mat-radio-group formControlName="saleType" aria-label="Select an option">
        <mat-radio-button value="Acquisition" style="margin-right: 10px">Acquisition</mat-radio-button>
        <mat-radio-button checked value="Renewal">Renewal</mat-radio-button>
      </mat-radio-group>

      <section class="field-group">
        <div class="field-holder w2">
          <mat-form-field appearance="standard" hideRequiredMarker="true">
            <mat-label>Product Type</mat-label>
            <mat-select formControlName="productType" required (selectionChange)="productSelectionChanged($event?.value)">
              <mat-option value="">-- Please Select --</mat-option>
              <mat-option
                *ngFor="let productType of (productTypes$ | async)?.length < 1 ? [{ productType: 'Fixed' }] : (productTypes$ | async)"
                [value]="productType.productType"
              >
                {{ productType.productType }}
              </mat-option>
            </mat-select>
            <mat-error> Please select a Product Type. </mat-error>
          </mat-form-field>
        </div>
      </section>

      <section class="field-group">
        <div class="field-holder contract-lengths" *ngIf="renewalsCustomerDetailsData.showContractLengths === true">
          <label>Contract Length (months)</label>
          <app-contract-lengths
            formControlName="contractLengths"
            [FilterMode]="false"
            [showAllButton]="true"
            [showPlusButton]="isDynamic$ | async"
            [contractLenghtsToShow]="[1, 3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36, 48, 60]"
            (notifyAllChanged)="allContractLengthsSelected($event)"
          >
          </app-contract-lengths>
          <mat-error
            *ngIf="
              renewalsCustomerDetailsData.contractLengths?.invalid &&
              (renewalsCustomerDetailsData.contractLengths.dirty || renewalsCustomerDetailsData.contractLengths.touched)
            "
          >
            Please select at least one Contract Length
          </mat-error>
        </div>
      </section>
      <!-- sweet spot checkbox won't be shown when contract lengths are not selectable -->
      <section *ngIf="renewalsCustomerDetailsData.showContractLengths === true">
        <br />
        <mat-checkbox
          id="sweetSpotCheckbox"
          color="primary"
          formControlName="sweetSpotCheckbox"
          (change)="sweetSpotCheckboxChanged($event)"
        >
          <span id="checkboxText">Include Sweet Spot for the full range</span>
        </mat-checkbox>
      </section>

      <app-billing-input [quoteRequestId]="renewalsCustomerDetailsData.quoteRequestId"> </app-billing-input>

      <h4>Notes</h4>
      <section class="field-group">
        <div class="field-holder w6">
          <textarea
            id="quoteConfigNotes"
            matInput
            formControlName="notes"
            rows="5"
            placeholder="Please add your additional pricing details here"
          ></textarea>

          <mat-error
            *ngIf="
              renewalsCustomerDetailsData.notes?.invalid &&
              (renewalsCustomerDetailsData.notes?.dirty || renewalsCustomerDetailsData.notes?.touched)
            "
          >
            Notes cannot exceed 255 characters
          </mat-error>
        </div>
      </section>
    </form>
  </div>

  <app-wizard-step-nav-buttons [hideBack]="true" (nextClicked)="next()"></app-wizard-step-nav-buttons>
</div>
